// recon-tax-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'rcs.payStatus.notApplicable': 'Not applicable',
  'rcs.payStatus.paidLate': 'Paid after the due date',
  'rcs.payStatus.paidAfterPeriod': 'Paid after period end',
  'rcs.payStatus.paid': 'Paid',
  'rcs.payStatus.partial': 'Partially paid',
  'rcs.payStatus.overdue': 'Overdue — not paid',
  'rcs.payStatus.notDue': 'Not yet due',
  'rcs.payStatus.noFee': 'No contribution in the period',
  'rcs.bookStatus.notBooked': 'Not booked',
  'rcs.bookStatus.booked': 'Booked',
  'rcs.bookStatus.difference': 'Booking difference',
  'rcs.bookStatus.ownTerm': 'Reconciled in its own term',
  'rcs.bookStatus.onSubmit': 'Settled on submission',
  'rcs.claimStatus.payrollRun': 'Calculated by the payroll run',
  'rcs.claimStatus.payrollSystem': 'Calculated by the payroll system',
  'rcs.claimStatus.fixed': 'Determined on submission',
  'rcs.claimStatus.notFixed': 'Not determined',
  'rcs.reported.withholdingYes': 'Reported in the A-melding',
  'rcs.reported.withholdingNo': 'Not registered as reported',
  'rcs.reported.vatSubmitted': 'VAT return submitted',
  'rcs.reported.vatDraft': 'Draft — not sent',
  'rcs.claim.withholdingTitle': 'Withholding tax – {label}',
  'rcs.claim.runPeriod': 'payroll {period}',
  'rcs.claim.runDate': 'run {date}',
  'rcs.claim.agaTitle': 'Employer contribution – term {term}',
  'rcs.claim.agaPeriod': 'Term {term} {year}',
  'rcs.claim.vatTitle': 'Value added tax – term {n}',
  'rcs.payment.description': 'Payment {title}',
  'rcs.payment.directPosting': 'Posting on control account',
  'rcs.vat.noTerm': 'No term found',
  'rcs.source.ledger': 'General ledger',
  'rcs.source.payroll': 'Payroll runs',
  'rcs.source.amelding': 'A-melding',
  'rcs.source.vat': 'VAT return for the term',
  'rcs.source.payments': 'Registered payments of tax and levies',
  'rcs.source.bank': 'Bank statement for the payments',
  'rcs.source.skatteetaten': 'Claim overview and balance from Skatteetaten',
  'rcs.source.ledgerDetail': '{count} postings on the control accounts in the period',
  'rcs.source.payrollDetailOne': '{count} booked run in the period',
  'rcs.source.payrollDetailMany': '{count} booked runs in the period',
  'rcs.source.payrollDetailNone': 'No booked payroll runs in the period',
  'rcs.source.ameldingNone': 'No runs to report',
  'rcs.source.ameldingDetail': '{reported} of {total} runs are registered as reported',
  'rcs.source.vatDetail': '{period} {year} · due {due}',
  'rcs.source.paymentsDetail': '{count} claims have a registered payment',
  'rcs.source.bankNone': 'No bank statement covers the period — the payments cannot be confirmed against the bank',
  'rcs.source.bankDetail': '{covered} of {total} registered payments are matched to a bank line',
  'rcs.source.skatteetatenDetail': 'Plumme does not fetch claims, KID or account statements from Skatteetaten. The claims below are the company\'s own calculated obligations with statutory due dates.',
  'rcs.check.accounts': 'All relevant control accounts are included',
  'rcs.check.balance': 'Booked balance has been compared with calculated claims',
  'rcs.check.withholdingPayroll': 'Withholding tax has been compared with payroll and the A-melding',
  'rcs.check.withholdingPayments': 'Withholding tax has been checked against registered payments',
  'rcs.check.withholdingDeadlines': 'Payment deadlines for withholding tax have been checked',
  'rcs.check.aga': 'Employer contribution matches the payroll system basis',
  'rcs.check.agaDeadline': 'The payment deadline for the employer contribution has been checked',
  'rcs.check.vat': 'The VAT settlement is linked to the VAT reconciliation',
  'rcs.check.partial': 'Partially paid claims have been identified',
  'rcs.check.bankCoverage': 'Registered payments are confirmed against the bank statement',
  'rcs.check.bankCoverageNone': 'Registered payments are confirmed against the bank statement (no bank statement covers the period)',
  'rcs.check.direct': 'Direct postings on control accounts have been identified',
  'rcs.check.overdue': 'Overdue public claims have been identified',
  'rcs.check.unbooked': 'All claims are booked as liabilities',
  'rcs.check.payrollBooked': 'All payroll runs in the period are booked',
  'rcs.role.withholding': 'Unpaid withholding tax at period end',
  'rcs.role.garnishment': 'Garnishment deductions are not calculated by the payroll model',
  'rcs.role.aga': 'Accrued employer contribution that has not been paid',
  'rcs.role.agaAccrued': 'Accrued contribution on holiday pay — reconciled in payroll',
  'rcs.role.vatSettlement': 'Submitted VAT return that has not been settled',
  'rcs.role.taxPayable': 'Accounting provision — no external source',
  'rcs.role.deferredTax': 'Accounting calculation — no external source',
  'rcs.role.advanceTax': 'The advance tax notice is not fetched by the app',
  'rcs.role.publicFees': 'Other public levies — no external source',
  'rcs.role.addedByFirm': 'Added to the tax area by the firm',
});
